"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.LOCALE_SEGMENT_NAME="locale";
//# sourceMappingURL=next-intl.cjs.production.min2.js.map
